import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import AuthPageShell from '@/components/auth/AuthPageShell';
import LoginForm from '@/components/auth/LoginForm';
import { SPACE_MD } from '@/theme/buildAntdTheme';

const Login = () => {
  const { t } = useTranslation();

  return (
    <AuthPageShell bannerTitle={t('LOGIN_BANNER_TEXT')} bannerSize={'small'}>
      <Flex vertical gap={SPACE_MD}>
        <Typography.Title level={2}>{t('LOGIN_TITLE')}</Typography.Title>
        <LoginForm />
      </Flex>
    </AuthPageShell>
  );
};

export default Login;
